import { useCallback, useRef, useState } from 'react'

export function useExclusivePanels(
  defaultLeft: boolean,
  defaultRight: boolean
) {
  const [leftOpen, setLeftOpen] = useState(defaultLeft)
  const [rightOpen, setRightOpen] = useState(defaultRight)
  const rightWasOpenRef = useRef(defaultRight)

  const toggleLeft = useCallback(() => {
    setLeftOpen((prev) => {
      if (!prev) {
        rightWasOpenRef.current = rightOpen
        setRightOpen(false)
      } else {
        setRightOpen(rightWasOpenRef.current)
      }
      return !prev
    })
  }, [rightOpen])

  const closeLeft = useCallback(() => {
    setLeftOpen(false)
    setRightOpen(rightWasOpenRef.current)
  }, [])

  const toggleRight = useCallback(() => {
    if (leftOpen) {
      setLeftOpen(false)
      setRightOpen(true)
    } else {
      setRightOpen((prev) => !prev)
    }
  }, [leftOpen])

  return { leftOpen, rightOpen, toggleLeft, closeLeft, toggleRight }
}
